import { CloseOutlined, LeftOutlined } from '@ant-design/icons'
import { Button, Drawer, Flex, Typography } from 'antd'
import { CSSProperties, ReactNode } from 'react'
import { styled } from 'styled-components'
import { DesignSystem } from '~/core/designSystem'

const Wrapper = styled(Drawer)`
  border: 4px solid blue;
  height: var(--100vh);

  .ant-drawer-content-wrapper {
    border: 4px solid blue;
  }

  .ant-drawer-body {
    position: relative;
    border: 4px solid red;
  }
`

type Props = {
  onClose: () => void
  children: ReactNode
}

export const ThreadDrawer: React.FC<Props> = ({ children, onClose }) => {
  const designSystem = DesignSystem.use()

  const { token } = designSystem.useToken()

  const styleMobile: CSSProperties = {
    position: 'absolute',
    top: 0,
    bottom: 0,
    right: 0,
    left: 0,
    background: token.colorBgBase,
  }

  const styleDesktop = {
    maxWidth: '500px',
    borderLeft: `1px solid ${token.colorBorderSecondary}`,
  }

  const style = designSystem.isMobile ? styleMobile : styleDesktop

  return (
    <>
      <Flex
        vertical
        style={{
          width: '100%',
          height: '100%',
          overflow: 'hidden',
          ...style,
        }}
      >
        <Flex
          className="p-2"
          gap={8}
          style={{ borderBottom: `1px solid ${token.colorBorderSecondary}` }}
          justify={designSystem.isMobile ? undefined : 'space-between'}
          align="center"
        >
          {designSystem.isMobile && (
            <Button
              type="text"
              size="small"
              icon={<LeftOutlined />}
              onClick={onClose}
            ></Button>
          )}
          <Typography.Title level={4} style={{ margin: 0 }}>
            Thread
          </Typography.Title>
          {!designSystem.isMobile && (
            <Button
              type="text"
              size="small"
              icon={<CloseOutlined />}
              onClick={onClose}
            ></Button>
          )}
        </Flex>
        <Flex flex={1} style={{ overflow: 'hidden' }}>
          {children}
        </Flex>
      </Flex>
    </>
  )
  return (
    <Wrapper
      open={true}
      onClose={onClose}
      mask={false}
      width={500}
      styles={{ body: { padding: 0, width: '100%' } }}
      title={
        <Flex justify="space-between" align="center">
          Thread{' '}
          <Button type="text" icon={<CloseOutlined />} onClick={onClose} />
        </Flex>
      }
      closeIcon={false}
    >
      <Flex vertical gap={16} className="h-full w-full">
        {children}
      </Flex>
    </Wrapper>
  )
}
